import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicReviewsExtension, ProductReviews } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { getExtensionRules, PRODUCT_RELATED_RULE_ENTITIES } from '../../../../../shared/all-extension-rules';
import { UpsellProduct } from '../../models';

@Component({
  selector: 'checkout-upsell-product-reviews',
  templateUrl: './checkout-upsell-product-reviews.component.html',
  styleUrls: ['./checkout-upsell-product-reviews.component.scss'],
  standalone: false,
})
export class CheckoutUpsellProductReviewsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() shopCurrencySymbol: string;

  @Output() addExcludedProducts = new EventEmitter<void>();
  @Output() removeExcludedProduct = new EventEmitter<string | number>();

  readonly ExclusionMode = ProductReviews.ExclusionMode;
  readonly minStarRatingStep = DynamicReviewsExtension.MIN_STAR_RATING_STEP;
  readonly minStarRatingMin = DynamicReviewsExtension.MIN_STAR_RATING_STEP;
  readonly minStarRatingMax = DynamicReviewsExtension.CSV_MAX_STAR_RATING;

  readonly exclusionModeOptions = [
    { value: ProductReviews.ExclusionMode.MANUAL, label: 'Manual' },
    { value: ProductReviews.ExclusionMode.SMART, label: 'Smart' },
  ];

  readonly positionOptions = [
    { value: ProductReviews.Position.TOP, label: 'Top' },
    {
      value: ProductReviews.Position.MIDDLE,
      label: 'Middle',
    },
    { value: ProductReviews.Position.BOTTOM, label: 'Bottom' },
  ];

  readonly excludeProductsRules = getExtensionRules({ onlyRules: PRODUCT_RELATED_RULE_ENTITIES });
  readonly excludeProductsEntities = this.excludeProductsRules.map((rule) => rule.entity);

  get isCsvSelected(): boolean {
    return this.formGroup.get('importMethod')?.value === ProductReviews.ImportMethod.CSV;
  }

  get isManualExclusion(): boolean {
    return this.formGroup.get('excludeProductsMode')?.value !== this.ExclusionMode.SMART;
  }

  get excludedProducts(): UpsellProduct[] {
    return this.formGroup.get('excludeProducts')?.value ?? [];
  }

  /**
   * Turning both display toggles off would leave the badge with nothing to draw, so the last one
   * standing switches the other back on.
   */
  onShowStarsToggled(enabled: boolean): void {
    if (!enabled && !this.formGroup.get('showNumberOfReviews').value) {
      this.formGroup.get('showNumberOfReviews').setValue(true);
    }
    this.formGroup.markAsDirty();
  }

  onShowNumberOfReviewsToggled(enabled: boolean): void {
    if (!enabled && !this.formGroup.get('showStars').value) {
      this.formGroup.get('showStars').setValue(true);
    }
    this.formGroup.markAsDirty();
  }

  setExclusionMode(mode: string): void {
    this.formGroup.get('excludeProductsMode')?.setValue(mode);
    this.formGroup.markAsDirty();
  }
}
